import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  eventTypeListReq,
  setSessionFilterBy,
  setSessionFilterByClear,
  setSessionFilterEventType,
  setSessionFilterEventTypeClear,
} from "../../../redux/events/actions";
// import { SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";

const CustomToolbar2 = (toolbar) => {
    console.log("toolbar",toolbar)

  const [isCurrent, SetIsCurrent] = useState("week");
  const [filterBy, setFilterBy] = useState("all");
  const [filterEventType, setFilterEventType] = useState("all");


  const dispatch = useDispatch();
  const role = useSelector((state) => state.user.role);
  const iframeRole = useSelector((state) => state.user.iframeRole);
  const sessionFilterBy = useSelector((state) => state.events.sessionFilterBy);
  const isMobileDevice = useSelector((state) => state.user.isMobileWebView);
  const eventTypeListRes = useSelector((state) => state.events.eventTypeList);

  const sessionFilterEventType = useSelector((state) => state.events.sessionFilterEventType);

  const [userRole, setUserRole] = useState('')
  const [typeList, setTypeList] = useState([]);

  useEffect(()=>{
    SetIsCurrent("week");
    toolbar.onView("week");
  },[])

  useEffect(() => {
    if (!_.isEmpty(sessionFilterEventType)) {
      setFilterEventType(sessionFilterEventType)
    }
  }, [sessionFilterEventType])

  useEffect(() => {
    console.log('getEventTypeListRes: ', eventTypeListRes)
    if (!_.isEmpty(eventTypeListRes)) {
      if (eventTypeListRes.status === "success") {
        let typeList = eventTypeListRes?.payload?.payload;
        setTypeList(typeList);
      }
    }
  }, [eventTypeListRes])

  useEffect(() => {
    console.log('isMOBILEDEVICE', isMobileDevice)
    if (isMobileDevice) {
      setUserRole(iframeRole)
    } else {
      setUserRole(role)
    }
  }, [role, iframeRole, isMobileDevice])

  useEffect(() => {
    console.log('filter by is changed', filterBy)
    // dispatch(setSessionFilterBy(filterBy));
    // toolbar.setSessionFilterBy(filterBy)
    return (() => {
      dispatch(setSessionFilterBy(''))
    })
  }, [filterBy]);

  // useEffect(() => {
  //   if (sessionFilterBy) {
  //     console.log(sessionFilterBy)
  //     setFilterBy(sessionFilterBy)
  //   }
  // }, [sessionFilterBy])

  useEffect(() => {
    // console.log(toolbar)
    if (toolbar.view) {
      SetIsCurrent(toolbar.view);
    }
  }, [toolbar]);

  const goToBack = () => {
    console.log("click")
    if (isCurrent === "month") {
      toolbar.date.setMonth(toolbar.date.getMonth() - 1);
    } else if (isCurrent === "day") {
      toolbar.date.setDate(toolbar.date.getDate() - 1);
    } else if (isCurrent === "week") {
      toolbar.date.setDate(toolbar.date.getDate() - 7);
    }
    toolbar.onNavigate("prev");
  };

  const goToNext = () => {
    if (isCurrent === "month") {
      toolbar.date.setMonth(toolbar.date.getMonth() + 1);
    } else if (isCurrent === "day") {
      toolbar.date.setDate(toolbar.date.getDate() + 1);
    } else if (isCurrent === "week") {
      toolbar.date.setDate(toolbar.date.getDate() + 7);
    }
    toolbar.onNavigate("next");
  };
  const handleToday = () => {
    // toolbar.onNavigate("TODAY")
    toolbar.onNavigate("TODAY");
    
  };

  const goToCurrent = () => {
    const now = new Date();
    toolbar.date.setMonth(now.getMonth());
    toolbar.date.setYear(now.getFullYear());
    toolbar.onNavigate("current");
  };

  const monthView = () => {
    SetIsCurrent("month");
    toolbar.onView("month");
  };
  const dayView = () => {
    SetIsCurrent("day");
    toolbar.onView("day");
  };
  const weekView = () => {
    SetIsCurrent("week");
    toolbar.onView("week");
  };
  

  const label = () => {
    const date = moment(toolbar.date);
    if (isCurrent === "month" || isCurrent === "week") {
      return (
        <span>
          <b>{date.format("MMMM")}</b>,<span> {date.format("YYYY")}</span>
        </span>
      );
    } else if (isCurrent === "day") {
      return (
        <span>
          {date.format("DD")}&nbsp;<b>{date.format("MMMM")}</b>,
          <span> {date.format("YYYY")}</span>
        </span>
      );
    }
  };
 const togglenavs = () => {
    var btnEl = document.querySelector(".sidecal");
    var main = document.querySelector(".full-cal");
    var toogleicon = document.querySelector(".arrow-side-cal")
   
    // console.log(btnClasslist)
    if (btnEl.classList.contains("open")) {
      //document.getElementById("openbtnd").innerHTML = "<span class='closetoogle'></span>";
      btnEl.classList.remove("open");
      toogleicon.classList.add("closeopen");
      main.style.width = "100%";
      
    } else {
      //document.getElementById("openbtnd").innerHTML ="<span class='opentogglbar'></span>";
      btnEl.classList.add("open");
      toogleicon.classList.remove("closeopen");
      main.style.width = "75%";
     
    }
  };
  return (
    <div className="mt-4 mb-4">
      <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap filter-box-sec">
        <div className="left-btnb">
        {true&&<button
              className={`btn btn-primary rounded-pill ${isCurrent === "today" ? "active" : ""
                }`}
              onClick={handleToday}
            >
              Today
            </button>}
        </div>
      <div className="filter-box-cal-update">
          <div className="d-flex button-filteralignmentnew align-items-center">
            <div className="button-cal-new">
              <span className="button-reset-next cursor-pointer" onClick={goToBack}>
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_2088_7986)">
                    <rect x="5.80005" y="3.90039" width="36" height="36" rx="18" fill="white" />
                    <rect x="5.80005" y="3.90039" width="36" height="36" rx="18" stroke="#415385" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M26.5657 17.106C26.4088 16.9487 26.1957 16.8604 25.9735 16.8604C25.7513 16.8604 25.5383 16.9487 25.3813 17.106L21.5257 20.9616C21.1981 21.2892 21.1981 21.8184 21.5257 22.146L25.3813 26.0016C25.7089 26.3292 26.2381 26.3292 26.5657 26.0016C26.8933 25.674 26.8933 25.1448 26.5657 24.8172L23.3065 21.5496L26.5657 18.2904C26.8933 17.9628 26.8849 17.4252 26.5657 17.106Z" fill="#415385" />
                  </g>
                  <defs>
                    <filter id="filter0_d_2088_7986" x="0.300049" y="0.400391" width="47" height="47" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset dy="2" />
                      <feGaussianBlur stdDeviation="2.5" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0.14902 0 0 0 0 0.2 0 0 0 0 0.301961 0 0 0 0.03 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2088_7986" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2088_7986" result="shape" />
                    </filter>
                  </defs>
                </svg>
              </span>
              {/* <label className="calendar-label-titlesmall">{label()}</label> */}
              <label className="calendar-label-titlesmall">{toolbar.label}</label>
              <span id="idNexCal" className="button-reset-next cursor-pointer" onClick={goToNext}>
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_2088_7987)">
                    <rect x="5.90015" y="3.90039" width="36" height="36" rx="18" fill="white" />
                    <rect x="5.90015" y="3.90039" width="36" height="36" rx="18" stroke="#415385" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.6258 17.1071C21.2982 17.4347 21.2982 17.9639 21.6258 18.2915L24.885 21.5507L21.6258 24.8099C21.2982 25.1375 21.2982 25.6667 21.6258 25.9943C21.9534 26.3219 22.4826 26.3219 22.8102 25.9943L26.6658 22.1387C26.9934 21.8111 26.9934 21.2819 26.6658 20.9543L22.8102 17.0987C22.491 16.7795 21.9534 16.7795 21.6258 17.1071Z" fill="#415385" />
                  </g>
                  <defs>
                    <filter id="filter0_d_2088_7987" x="0.400146" y="0.400391" width="47" height="47" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset dy="2" />
                      <feGaussianBlur stdDeviation="2.5" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0.14902 0 0 0 0 0.2 0 0 0 0 0.301961 0 0 0 0.03 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2088_7987" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2088_7987" result="shape" />
                    </filter>
                  </defs>
                </svg>

              </span>
            </div>
          </div>
        
        </div>
        <div className="left-btn-cl-boxf">
          <div className="d-flex blsecd">
            <button
              className={`setup-buttondone ${isCurrent === "day" ? "active" : ""
                }`}
              onClick={dayView}
            >
              Day
            </button>
            {false && <button
              className={`setup-buttondone ${isCurrent === "month" ? "active" : ""
                }`}
              onClick={monthView}
            >
              Month
            </button>}
            <button
              className={`setup-buttondone ${isCurrent === "week" ? "active" : ""
                }`}
              onClick={weekView}
            >
              Week
            </button>
          </div>
          <div className="arrow-side-cal cursor-pointer closeopen" onClick={togglenavs}>          
          </div>
        </div>      
      </div>
    </div>
  );
};

export default CustomToolbar2;
